import {PlayerReducer, ReducerFromState} from "../../../@types/reducers";

export const getPlayerBooks = (state: ReducerFromState<PlayerReducer>): number[] => state.player.books;